import "./VPNComplianceDataProtection.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Comparison from "./sections/Comparison";
import Vpnsecurityarchitecture from "./sections/Vpnsecurityarchitecture";
import Infrastructure from "./sections/Infrastructure";
import RelatedArticlesGrid from "./sections/RelatedArticlesGrid";
import Footer from "@/reusable_sections/Footer";
export default function VPNComplianceDataProtectionPage() {
  return <div>
      <Header />
      <Hero />
      <Comparison />
      <Vpnsecurityarchitecture />
      <Infrastructure />
      <RelatedArticlesGrid />
      <Footer />
    </div>;
}